import * as React from 'react';
import AssetsManager from '../utils/AssetsManager';

const LandingCheck = ({text}) =>
    <div className="row landing-check mb-3 mt-3">
        <div className="col-2 check d-flex align-items-center justify-content-center">
            <img src={
                AssetsManager('/assets/images/common/landing-check.svg')
            } className="img-fluid" alt="check"/>
        </div>
        <div className="col description">
            {text}
        </div>
    </div>;

export default LandingCheck;
